export const demoData = {
  version: 1.0,
  title: "Monday.com Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step0_Titlecard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Add a monday.com board to a Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "With the monday.com app in Teams,  employees can easily plan, organize, and track work on collaborative projects in one centralized location.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "82%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “General” is open. The icon bar lists nine icons: Activity, Chat, Teams, Calendar, Calls, Files, and an ellipsis. The App and Helps icons are at the bottom.",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Navigate to a Teams channel",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "27%",
              x: "7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up points to the Marketing Leadership Teams Channel.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Click the plus sign to add a new tab",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6.6%",
              x: "56.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view has changed to the Marketing Leadership Team channel. There's a horizontal bar of icons at the top of the channel: Posts, Files, Meeting Marketing, and a plus sign. A purple pop-up points to the plus sign icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Search for monday.com",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "11%",
              x: "58.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image4"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a pop-up appears titled 'Add a tab' showing a list of available apps. A purple pop-up points to a search bar in the upper right-hand corner of the pop up.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click the monday.com icon",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "26%",
              x: "33.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "After the user begins to type “Monday” in the search field, the monday.com icon pops up. A purple pop-up points to the monday.com app.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Use the drop-down menu to create a new board",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44.4%",
              x: "56%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image6"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the monday.com icon, and a new pop-up as appeared giving users the option to add a monday.com board to the channel. A purple pop-up points to a drop-down.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Users can also get started with one of the 200+ monday.com board templates specific to industries and workflows.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image7"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "n the same view, the user has clicked the dropdown and a list of boards has appeared. A purple pop-up points to 'Create a new board'.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "48.4%",
              x: "42.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image7"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view the user has selected 'Create a new board', and a purple pop-up points to a 'Save' button on the pop-up.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Press save",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "73.5%",
              x: "61.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step1_Image8"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "n the same view the user has selected 'Create a new board', and a purple pop-up points to a 'Save' button on the pop-up.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Customize the title of the board",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "22%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step1_Image10"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "Once the user clicks save, the new monday.com board has been saved as a tab, and the view shows the board. There is a purple pop-up on the top left where the user can customize the title of the new board.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Click the icon to add board members",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "22%",
              x: "84%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step1_Image11"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "Monday_Step1_Image11",
              "Monday_Step1_Image12",
              "Monday_Step1_Image13",
            ],
          },
          screenReaderText:
            "In the same view, the user has clicked the board title field, and it’s now blank. In the same view, the user titles the board “Q2 Planning”. In the same view, there are two tabs on the top right, Integrate and Automate. Next to the tabs are two text boxes. The first text box has a purple pop-up highlighting the people icon and the second text box is titled “Activities”.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "42%",
              x: "49%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step1_Image15"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "When the user clicks the people icon a text box appears to add Board Members.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "48%",
              x: "49.4%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step1_Image16"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has searched for 'Nestor' and purple pop-up points to the name 'Nestor Wilke' in the search results.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "35.3%",
              x: "74.2%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step1_Image17"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked Nestor’s name, adding him as a board member along with Megan Bowen and Adele Vance. A purple pop-up prompts the user to close the window and return to the monday.com board.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Create a group to break down large projects into smaller steps",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44.9%",
              x: "68%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step1_Image18"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view has returned to the Q2 Planning monday.com board. A purple rectangle outlines the first Group and task.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Title the group",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "36.6%",
              x: "42%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image19"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "A purple pop-up appears next to “Group Title”.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "Add tasks to the group",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "30%",
              x: "68%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image20"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "Monday_Step1_Image20",
              "Monday_Step1_Image21",
              "Monday_Step1_Image22",
            ],
          },
          screenReaderText:
            "Once the user clicks on the purple pop-up next to “Group Title”, the title name disappears and there is blank text box to fill in the new title. In the same view, the user renames the Group 'Marketing initiatives'. In the same view, a purple pop-up points to a blue button titled “New item”. ",
        },
        {
          id: 24,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image23"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "When the user clicks on “New Item”, a new field for a task appears under Marketing initiative group header.",
        },
        {
          id: 25,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image25"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points the new item, prompting the user to re-title the task. In the same view, the user titles the task 'Email campaigns'. A purple pop-up points to a task directly below 'Email campaigns' prompting the users to rename the next task.",
        },
        {
          id: 27,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image27"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user selected the drop-down carrot and chose “Plan Campaigns” for Task 1.",
        },
        {
          id: 28,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "47.7%",
              x: "43.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image28"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "n the same view, a purple pop-up points to the +Add task option below “Plan Campaigns”.",
        },
        {
          id: 29,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "47.5%",
              x: "92.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image29"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user titles the new task “Brainstorm” and a purple pop-up points to the “Add” button to add the task.",
        },
        {
          id: 30,
          card: {
            transition: false,
            text: "Press the plus sign to add columns to the group",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "37%",
              x: "95.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image30"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user adds another task titled “Update marketing calendar”. There are 4 tasks showing – Email campaigns, Plan campaigns, Brainstorm and Update marketing calendar. A purple pop-up icon points to the plus sign to add columns to the “Marketing initiatives” group.",
        },
        {
          id: 31,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "45.1%",
              x: "78.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image31"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a pop-up window appears showing 6 “Essential” column options – Status, Text, People, Dropdown, Date and Numbers. There are 8 “Super Helpful” column options – Subitems, Files, Connect boards, Last updated, Timeline, Formula, Tags, Creation log. There is a purple pop-up over the “Status” option.",
        },
        {
          id: 32,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "37%",
              x: "95.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image32"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a “Status” column now appears for the tasks. A purple pop-up icon appears over the plus sign to add additional columns to the “Marketing initiatives” group.",
        },
        {
          id: 33,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "48.2%",
              x: "87.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image33"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the pop-up window appears showing the 6 “Essential column options and 8 “Super Helpful” column options. A purple pop-up icon points to “Date”.",
        },
        {
          id: 34,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "37%",
              x: "95.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image34"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a “Date” column now appears next to the “Status” column. A purple pop-up icon appears over the plus sign to add additional columns to the “Marketing initiatives” group.",
        },
        {
          id: 36,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "51.4%",
              x: "78.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image36"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the pop-up window appears showing the 6 “Essential column options and 8 “Super Helpful” column options. A purple pop-up icon points to “People”.",
        },
        {
          id: 37,
          card: {
            transition: false,
            text: "monday.com features over 30 drag and drop column options, which allow users to customize the type information that is most important for a given project.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image37"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a “People” column now appears next to the “Date” and “Status” columns.",
        },
        {
          id: 38,
          card: {
            transition: false,
            text: "Click the status to indicate progress on an item",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40%",
              x: "76.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image38"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up icon is over the first row, “Email campaigns”, in the “Status” column.",
        },
        {
          id: 39,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "49.5%",
              x: "73%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image39"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up window appears with 3 “Status” options – Done, Working on it, and Stuck. A purple pop-up icon points to “Working on it”.",
        },
        {
          id: 40,
          card: {
            transition: false,
            text: "Status labels are fully customizable and can also be used to represent the priority of the item, the type of the project, or anything else users want to show visually.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image40"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Under the status column, row 1 “Email campaigns”, “Working on it” now shows as the status.",
        },
        {
          id: 41,
          card: {
            transition: false,
            text: "Enter a due date or timeline to create a clear project schedule",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40%",
              x: "84.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image41"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up icon is over the first row, “Email campaigns”, in the “Date” column.",
        },
        {
          id: 42,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "49.4%",
              x: "91.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image42"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up window appears to select a date with the purple pop-up icon highlighting the forward arrow to advance to a new month. ",
        },
        {
          id: 43,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "60%",
              x: "87%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image43"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "A purple pop-up icon points to April 9, 2021.",
        },
        {
          id: 44,
          card: {
            transition: false,
            text: "Assign people to specific projects or tasks to improve ownership",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40.5%",
              x: "91.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image44"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Under the Date column, Apr 9 now shows in row 1. A purple pop-up icon points to the “People” column.",
        },
        {
          id: 45,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "54.4%",
              x: "80.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image45"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up window appears for the user to search a name. There are 3 names listed in the pop-up window, Megan Bowen, Adele Vance and Nestor Wilke. A purple pop-up icon points to the name Adele Vance.",
        },
        {
          id: 46,
          card: {
            transition: false,
            text: "Create additional groups based on the project needs",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "36.6%",
              x: "40.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image46"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Under the People column, in row 1, there is an “A” representing Adele Vance. On the left side of the group box, a purple pop-up points at the drop-down carrot next to the Marketing initiatives group name.",
        },
        {
          id: 47,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "51.2%",
              x: "41.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image47"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up window appears with 11 options – Collapse this Group, Expand all Groups, Select all Items, Add Group, Duplicate this Group, Move Group to Board, Rename Group, Change Group Color, Export to Excel, Delete and Archive. A purple pop-up points to “Add Group”.",
        },
        {
          id: 48,
          card: {
            transition: false,
            text: "Return to the Teams channel to view the notification for the newly created the board",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "8.8%",
              x: "44.1%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image48"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A New Group box now shows below the Marketing initiatives group.",
        },
        {
          id: 49,
          card: {
            transition: false,
            text: "Users can also share boards and items in chat messages and channels with the monday.com  message extension in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step1_Image49"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Share updates and customize monday.com board displays",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "The monday.com app lets Teams users record project updates and see recent activity on project boards.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step2_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “Design” is open. A horizontal icon bar at the top of the channel lists 5 tabs: Posts, Files, Wiki, Video projects and a Plus sign icon.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the monday.com board",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6.5%",
              x: "42.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step2_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up points to the “Video projects” tab.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Select an item",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "51%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view has changed to show a monday.com board titled Video projects. There are 6 videos listed on the board –Campaign video management, Tailspin campaign video, Fabrikam  campaign video, Contoso explainer video, Mark8 campaign video. A purple pop-up point to “Contoso explainer video”.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Write an update for the item to keep team members informed on progress",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "37.5%",
              x: "61.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image4a"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A “Contoso explainer video” window pops up. There are 3 tabs at the top of the window – Updates, Info Boxes and Activity Log. The Update tab is selected. A purple pop-up points to the “Write an update” text box.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "51.3%",
              x: "94.4%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step2_Image4a"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "Monday_Step2_Image4a",
              "Monday_Step2_Image4b",
              "Monday_Step2_Image5",
            ],
          },
          screenReaderText:
            "The user types “Almost ready for an internal review!” into the text box. A purple pop-up points to the “Update” button in the window. ",
        },
        // {
        //   id: 6,
        //   card: {
        //     transition: false,
        //     text: "Use the Info Boxes tab to add files to items",
        //     snack: {
        //       isVisible: false,
        //       position: "right",
        //     },
        //     position: {
        //       y: "31%",
        //       x: "67.7%",
        //     },
        //     beacon: {
        //       isVisible: true,
        //       position: "bottom",
        //     },
        //   },
        //   images: {
        //     name: ["Monday_Step2_Image6"],
        //     imageAltText: "",
        //     sequence: false,
        //     sequenceSources: [],
        //   },
        //   screenReaderText:
        //     "In the same window, the new text update, “Almost ready for an internal review!”, is below Megan Bowen’s name. A purple pop-up icon is pointing at the second tab, “Info Boxes”.",
        // },
        // {
        //   id: 6,
        //   card: {
        //     transition: false,
        //     text: "Choose the Activity Log to view recent activity on the item",
        //     snack: {
        //       isVisible: false,
        //       position: "right",
        //     },
        //     position: {
        //       y: "30.8%",
        //       x: "73.4%",
        //     },
        //     beacon: {
        //       isVisible: true,
        //       position: "bottom",
        //     },
        //   },
        //   images: {
        //     name: ["Monday_Step2_Image7"],
        //     imageAltText: "",
        //     sequence: false,
        //     sequenceSources: [],
        //   },
        //   screenReaderText:
        //     "In the same view, a purple pop-up icon is point at the third tab, “Activity Log”. In the same view, a purple pop-up icon is point at the third tab, “Activity Log”.",
        // },
        // {
        //   id: 7,
        //   card: {
        //     transition: false,
        //     text: "",
        //     snack: {
        //       isVisible: false,
        //       position: "right",
        //     },
        //     position: {
        //       y: "20%",
        //       x: "60.25%",
        //     },
        //     beacon: {
        //       isVisible: true,
        //       position: "bottom",
        //     },
        //   },
        //   images: {
        //     name: ["Monday_Step2_Image8"],
        //     imageAltText: "",
        //     sequence: false,
        //     sequenceSources: [],
        //   },
        //   screenReaderText:
        //     "The most recent activity log now appears in the window showing 9 most recent activities and an icon option to filter the log. A purple pop-up prompts the user to close the window and return to the Video Projects board.",
        // },
        {
          id: 8,
          card: {
            transition: false,
            text: "Select the drop-down arrow next to the Main Table to add a view",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "30%",
              x: "48.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step2_Image9"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Under Video Project, the “Main Table/2” tab has a purple pop-up icon highlighting the drop-down carrot next to the tab. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Choose the Add View button",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "51%",
              x: "42%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image10"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up window appears with the option to select “Main Table” or “+ Add View”. A purple pop-up points to “+Add View”. A pop-up window appears with the option to select “Main Table” or “+ Add View”. A purple pop-up points to “+Add View”.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Select Timeline",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "70.5%",
              x: "58%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image11"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A drop-down appears to the right of “+Add View” with 11 different view options to select from – Table, Gantt, Calendar, Chart, Kanban, Form, Timeline, Workload, Files, Apps and More views. A purple pop-up icon points to “Timeline”.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Click the Filter button to further refine the display",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "21.4%",
              x: "76.4%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image12"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A timeline for Megan Bowen, Adele Vance and Nestor Wilke’s video projects shows on the screen. A highlighted purple rectangle box shows the option to filter the timeline.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Return to the View drop-down menu",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "19.5%",
              x: "52%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["Monday_Step2_Image13"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points at “Timeline/3” drop-down carrot on the top left of the screen.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Add the Files View to show all files uploaded to a board",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44%",
              x: "47%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image14"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up window appears with a purple pop-up icon pointed at “+Add View”.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image15"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A drop-down appears to the right of “+Add View” with 11 different view options to select from – Table, Gantt, Calendar, Chart, Kanban, Form, Timeline, Workload, Files, Apps and More views. A purple rectangle outlines “Files”.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Add the Workload View to see how work is divided and gauge teammate capacity",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "66.5%",
              x: "63.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image16"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up icon is points to “Workload” in the dropdown.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Project collaborators can also save additional filtered views, such as Search, Person, and Filter to further customize the board display and quickly find relevant information.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step2_Image17"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A workload calendar for Megan Bowen, Adele Vance and Nestor Wilke’s video projects shows on the screen.",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Set notifications and add tasks with the monday.com bot",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "With the monday.com bot, users can stay up-to-date on what’s important by receiving Teams notifications about project updates and add new tasks to monday.com boards.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “General” is open. A horizontal tab bar across the top shows 3 tabs – Post, Files, Wiki. A vertical icon bar on the far left of the screen shows 8 icons- Activity, Chat, Teams, Calendar, Calls, Files, monday.com and three ellipses.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Select the monday.com icon in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40.2%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up icon points to the monday.com icon on the left icon bar. ",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Login to monday.com",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "52.4%",
              x: "33.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the monday.com icon, and the monday.com bot is now open. The tab bar across the top shows 4 tabs –Chat, Inbox, My Week, and About. There’s a welcome cart in the bot chat. A purple pop-up points to “Login” button on the welcome card.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click the add-notifications button in the card",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "78%",
              x: "42%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step3_Image4"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "Megan Bowen logs in successfully and a new card appears in the chat. A purple pop-up points to a button on the card titled “add notifications”.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Use the drop-down menu to choose which board to receive notifications from",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "78%",
              x: "54%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “add notifications” and a new card appears in the chat titled “add notifications from monday.com boards. A purple pop-up points to a drop-down to select the board you want to receive a notification.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "85%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image6"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the dropdown, displaying a vertical list of 6 boards– Sales Pipeline, Monthly team planning, Webinar management, Q2 2021 projects, Q2 planning and Video project. A purple pop-up points to “Video projects”.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Press the receive notifications button",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "83%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image7"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has selected “Video projects” from the dropdown, and a purple pop-up points to a button on the card that reads “Receive notifications”.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "With notifications on, users will receive messages from monday.com when they are assigned tasks, mentioned in updates, and more. Notifications can be customized in the automations center.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "75%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image8"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Click the text box to see additional ways the monday.com bot can assist",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image9"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "88%",
              x: "62.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image10"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a drop-down has appeared above the chat bar that reads “What can I do?”.  A purple pop-up points to a dropdown. ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Select create-item from the dropdown menu",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "66%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image11"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A pop-up window appears with 9 options – login, create-item, add-notifications, remove-notifications, logout, sign-up, help, provide feedback, take-a-tour. A purple pop-up points to “create-item”.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.5%",
              x: "71.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image12"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, “create-item” now appears in the chat bar. A purple pop-up points to the send icon below the chat bar.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Choose the board to add an item",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "54%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image13"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has entered “create-item” into the chat and a new card has appeared that reads “Create a new item – step ½”. A purple pop-up points to a dropdown prompting the user to select an item.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image14"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a dropdown now shows n the card displaying six board choices – Sales Pipeline, Monthly team planning, Webinar management, Q2 2021 projects, Q2 planning and Video project. A purple pop-up points to “Video projects”.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Click Next",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "33.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image15"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has selected the “Video projects” board, and a purple pop-up now points to a button on the card that reads “Next”.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Select the group",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "70.5%",
              x: "53.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image16"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “Next” and a new card appears in the chat that reads “Create a new item – step 2/2 (Video projects board). The card has two dropdowns, Select a group and Enter item’s name. A purple pop-up points to the “Select a group” dropdown.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step3_Image17"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has clicked the select a group dropdown. A purple pop-up points to the only option, Q2 videos.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "Enter the item name",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "32.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image18"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has selected Q2 videos and a purple pop-up now points to the second dropdown on the card, “Enter item’s name.” ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Click next",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "33.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image19"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user types “Spring social gifs” into the “Enter item’s name” field” on the card, and a purple pop-up points to a button on the card that reads “Next”.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "Press the button in the card to open the board in monday.com, or view the board in the tab Teams channel tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "80%",
              x: "33.8%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step3_Image20"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has clicked “Next”, and a new card appears in the chat that reads “Item created successfully” There’s an option to open the item in monday.com, and a purple box outlines this new card.",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Manage your work with the personal space tabs.",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "The monday.com personal space tabs – Inbox and My Week – highlight upcoming tasks and deadlines for you and your team so you will never miss a due date.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "80%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Select the monday.com icon in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "40%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up points to the monday.com icon on the left icon bar.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the Inbox tab to view recent board activity",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6%",
              x: "17%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step4_Image3"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The view has changed to the monday.com bot chat. The horizontal tab bar across the top shows 4 tabs –Chat, Inbox, My Week, About. A purple pop-up points to “Inbox” on the tab bar.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Choose an item to see details about the update",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "28%",
              x: "50.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image4"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the inbox tab showing two notifications. One from Adele Vance and one from Megan Bowen. A purple pop-up points to a check box next to the Adele Vance notification.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Celebrate success by liking notifications or posting replies",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "44%",
              x: "17%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image5"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up icon points to the “like” button on the notification card from Adele  Vance noting that the spring social gif is complete.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "50%",
              x: "11.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image6a"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “write a reply” field on the notification card for Adele Vance. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "60%",
              x: "46%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image6a"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "Monday_Step4_Image6a",
              "Monday_Step4_Image6b",
              "Monday_Step4_Image7",
            ],
          },
          screenReaderText:
            "In the same view the user types “Great work on this, team!” in the reply field. A purple pop-up points to a button on the card that reads “reply”.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Select the My Week tab to view completed and upcoming deadlines",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6%",
              x: "20.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step4_Image8"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view the user has clicked the reply button, and a purple pop-up now points to the “My Week” tab at the top of the screen.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Managers can add their team members to track workloads and offer support.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "84%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step4_Image9"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view has changed to a monday.com dashboard showing Megan Bowen’s tasks for the week of March 29 thru April 4. A purple box highlights a task under the header “Today” that reads “Email campaigns”.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Select an upcoming item",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "61%",
              x: "68.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image10"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to text on the Email campaigns task that reads “Today”.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "View the card with summary information",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "65%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image11"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked “Today” on the task and a pop-up window has appeared that lists the group, status, date, and people assigned to the task.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Click the status button to update progress on an item",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "55.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step4_Image12"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view a purple pop-up points to the “Status” section of the card.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "65.5%",
              x: "51.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step4_Image13"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked “Working on it”, displaying a drop down that reads Done, Working on it, or Stuck. A purple pop-up icon points to “Done”.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "Extend a deadline from within the card by clicking on the date",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "67%",
              x: "62%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image14"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, after clicking to update the status to “Done”, a purple box outlines the date field, which reads April 2.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Users can also enter updates on the item by selecting the Start Conversation button in the card.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "84%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step4_Image15"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Head to the Teams store to get started",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "To get the monday.com app, head to the Teams Store",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "90%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step5_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “General” is open. A vertical icon bar on the left-side of the screen shows 9 icons- Activity, Chat, Teams, Calendar, Calls, Files, three ellipses, Apps, Help. A purple pop-up points to the “Apps” icon.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Search for monday.com",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13%",
              x: "10%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step5_Image2"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText:
            "The Apps page is open and a purple pop-up points to the search bar in the top left corner of the screen. ",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the monday.com icon",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13%",
              x: "42%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["Monday_Step5_Image2"],
            imageAltText: "",
            sequence: true,
            sequenceSources: [
              "Monday_Step5_Image2",
              "Monday_Step5_Image3",
              "Monday_Step5_Image4",
            ],
          },
          screenReaderText:
            "The user types “monday” into the search bar, and several cards have appeared in the search results. A purple pop-up points to the monday.com result.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Install the app and sign in",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "28.2%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step5_Image5"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked the Monday.com tile, and a pop-up has appeared prompting the user to add the Monday.com app to teams. A purple pop-up points to an “Add” button on the pop-up.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Work with your Teams administrator to pin the app to the menu bar for the entire organization.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "84%",
              x: "50%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["Monday_Step5_Image6"],
            imageAltText: "",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has added the Monday.com app to teams, and the view has changed to show the Monday.com bot channel. There is a card in the chat prompting the user to sign in or login to an existing account.",
        },
      ],
    },
    {
      id: 6,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["Monday_Step6_endcard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
